<auto-main-navigation></auto-main-navigation>

<!--<div class="filters-placeholder">Filters</div>-->

<div class="wrapper">

  <h2 class="p-align-center">Welcome Back, {{name}}!</h2>
  <input type="search"
    pInputText
    placeholder="Search Account Name or ID"
    [(ngModel)]="search"
    (input)="onSearchInput()" />

  @if (!showLoadingSpinner) {
    <p-paginator (onPageChange)="onPageChange($event)"
      [totalRecords]="filteredAccounts.length"
      [first]="first"
      [rows]="rows"
      [showFirstLastIcon]="false"
      [alwaysShow]="false"
      >
    </p-paginator>
  }

  @if (showLoadingSpinner) {
    <p-progressSpinner></p-progressSpinner>
  }

  <div class="account-list">
    @for (account of currentPageData; track account) {
      <auto-account-card
        [account]="account"
        [permissions]="permissions[account.accountId]"
        >
      </auto-account-card>
    }
  </div>

  @if (!showLoadingSpinner) {
    <p-paginator (onPageChange)="onPageChange($event)"
      [totalRecords]="filteredAccounts.length"
      [first]="first"
      [rows]="rows"
      [showFirstLastIcon]="false"
      [alwaysShow]="false"
      >
    </p-paginator>
  }
</div>

<auto-footer></auto-footer>
